// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"53ce39b3","453":"3e681bb8"}[chunkId] + ".chunk.js";
};